export default "__VITE_ASSET___8CfX2tH__"